
export const adminViewsRoles = ['admin', 'manager', 'reviewer']
export const merchantViewRoles = ['merchant']
export const partnerRoles = ['partner']